export const isEmpty = (val) => {
  return (
    val === undefined || // remove undefined
    val === "" || // remove empty string
    val === " " || // remove blank string
    (typeof val === "object" &&
      !Array.isArray(val) &&
      Object.keys(val).length === 0) || // remove empty object
    (Array.isArray(val) && val.length === 0) // remove empty array
  );
};

export const cleanObjectExcept = (obj, exceptions = [], currentPath = '') => {
  const isEmpty = (value) => {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string' && value.trim() === '') return true;
    if (Array.isArray(value) && value.length === 0) return true;
    if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) return true;
    return false;
  };

  if (obj == null) return undefined;

  const isExcepted = exceptions.some(exc => {
    if (exc === currentPath) return true;
    if (exc === 'prd_ser.prd_url_txt') {
      return /^prd_ser\.\d+\.prd_url_txt$/.test(currentPath);
    }
    return false;
  });

  if (isExcepted) {
    return obj;
  }

  if (typeof obj !== 'object') {
    return isEmpty(obj) ? undefined : obj;
  }

  const isArray = Array.isArray(obj);
  const cleaned = isArray ? [] : {};

  Object.entries(obj).forEach(([key, value]) => {
    const newPath = currentPath ? `${currentPath}.${key}` : key;
    const recursedValue = cleanObjectExcept(value, exceptions, newPath);
    if (recursedValue !== undefined) {
      if (isArray) {
        cleaned.push(recursedValue);
      } else {
        cleaned[key] = recursedValue;
      }
    }
  });

  return isEmpty(cleaned) ? undefined : cleaned;
};

export function processSupportingInfo(supportingInfo) {
  const result = {};

  const stripUnits = (value) => {
    if (typeof value !== "string") return value;

    // Remove common units and keep only numeric part (including decimals)
    const numericMatch = value.match(/[\d.]+/);
    return numericMatch ? numericMatch[0] : "";
  };

  supportingInfo?.forEach((item) => {
    const category = item.category?.coding?.[0]?.code;
    if (!category) return;

    // Check for absence reasons
    const isAbsent = item.reason?.coding?.some((c) =>
      c.system?.includes("absence-reason")
    );

    if (isAbsent) {
      result[category] = null;
      return;
    }

    // Handle different value types
    if (item.valueQuantity) {
      const rawValue = `${item.valueQuantity.value} ${item.valueQuantity.code}`;
      result[category] = stripUnits(rawValue);
    } else if (item.valueString) {
      result[category] = stripUnits(item.valueString);
    } else if (item.code) {
      result[category] =
        item.code.text ||
        item.code.coding?.[0]?.display ||
        item.code.coding?.[0]?.code ||
        null;
    } else if (item.valueAttachment) {
      result[category] = item.valueAttachment.title || null;
    } else {
      result[category] = null;
    }
  });

  return result;
}
